import { useWhatsappSocket } from './useWhatsappSocket';

export function WhatsappSocketInit(): null {
  useWhatsappSocket();
  return null;
}
